import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatSort
} from '@angular/material';
import 'rxjs/add/observable/of';
import { TripService } from '../../../services/trip/trip.service';
import { TripdetailsComponent } from '../tripdetails/tripdetails.component';
import { DatePipe } from '@angular/common';
import { TokenStorage } from 'src/app/auth/token.storage';
import { UsersService } from 'src/app/services/users/users.service';

@Component({
  selector: 'app-triplistview',
  templateUrl: './triplistview.component.html',
  styleUrls: ['./triplistview.component.scss']
})
export class TriplistviewComponent implements OnInit {

  columnsToDisplay = [];
  tripDataArray = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  typeOfOrder:any='inplanning';

  mapView = false;
  inPlanningCount = 0;
  scheduledCount = 0;
  intransitCount = 0;
  completedCount = 0;
  incomplete = 0;
  page = 0;
  totalRecords: number;
  typeOfTrip: string;
  fromDate: any;
  toDate: any;
  selectedVal = '0';
  isTenantDiag = false;
  isVijaya = false;
  userActivityCount = 0;
  userActivityList = [];
  buttonColor = "accent";
  isLoading: boolean = false;
  constructor(
    public dialog: MatDialog,
    private tripService: TripService,
    private datePipe: DatePipe,
    private token: TokenStorage,
    private userService: UsersService
  ) {
    if (token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
      if (token.getTenant() == 'vijaya-reta-prod') {
        this.columnsToDisplay = [
          'vehicle',
          'department',
          'tripName',
          'tripCreatedOn',
          'totalNumOrders',
          'delayTime',
          'originAddress',
          'destinationAddress',
        ]
      } else {
        this.columnsToDisplay = [
          'vehicle',
          'department',
          'tripName',
          'tripCreatedOn',
          'tripZone',
          'originAddress',
          'destinationAddress',
          'totalNumOrders',
        ]
      }
    } else {
      this.columnsToDisplay = [
        'vehicle',
        'tripName',
        'tripCreatedOn',
        'tripZone',
        'originAddress',
        'destinationAddress',
        'totalNumOrders',
        'totalCapacity'
      ]
    }
  }

  ngOnInit() {
    if (this.token.getTenant() == 'vijaya-reta-prod') {
      this.isVijaya = true;
    }
    if(this.token.getCustomerType()== 'Diagnostic'){
      this.typeOfTrip = 'TRIP_STATE_IN_TRANSIT';

      let activityDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.userService.getAllUserActivity(activityDate, activityDate).subscribe(activity => {
        if(activity) {
          this.userActivityCount = activity.length;
          this.userActivityList = activity;
        }
      }, () => {
        this.userActivityCount = 0;
        this.userActivityList = [];
      });
    } else {
      this.typeOfTrip = 'TRIP_STATE_IN_PLANNING';
    }
    this.findTrips(this.selectedVal);

    this.tripDataArray.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'vehicle': {
          if (item.driver && item.driver.firstName && item.driver.lastName)
            return item.driver.firstName + " " + item.driver.lastName
          else if (item.driver && item.driver.firstName)
            return item.driver.firstName
        }
        case 'tripZone': return item.tripZone;
        case 'tripCreatedOn': return item.tripCreatedDateTime;
      }
    };
    this.tripDataArray.sort = this.sort;
  }

  findTripCount() {
    this.tripService.getTripCountByStatus(this.fromDate, this.toDate).subscribe(res => {
      console.log("trip count by status", res);
      this.inPlanningCount = 0;
      this.scheduledCount = 0;
      this.intransitCount = 0;
      this.completedCount = 0;
      this.incomplete = 0;
      if (this.searchArraryForCount(res, 'TRIP_STATE_IN_PLANNING') != undefined) {
        this.inPlanningCount = this.searchArraryForCount(res, 'TRIP_STATE_IN_PLANNING').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_SCHEDULED') != undefined) {
        this.scheduledCount = this.searchArraryForCount(res, 'TRIP_STATE_SCHEDULED').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_IN_TRANSIT') != undefined) {
        this.intransitCount = this.searchArraryForCount(res, 'TRIP_STATE_IN_TRANSIT').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_COMPLETED') != undefined) {
        this.completedCount = this.searchArraryForCount(res, 'TRIP_STATE_COMPLETED').tripcount;
      }
      if (this.searchArraryForCount(res, 'TRIP_STATE_INCOMPLETE') != undefined) {
        this.incomplete = this.searchArraryForCount(res, 'TRIP_STATE_INCOMPLETE').tripcount;
      }
    });
  }

  getDelay(trip) {
    return this.tripService.getFormattedTime(trip.tripDelayDuration * 1000);
  }

  searchArraryForCount(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].tripstatus === value) {
        return arr[i];
      }
    }
  }

  toogleView() {
    if (!this.mapView) {
      this.mapView = true;
      console.log(this.mapView);
    } else {
      this.mapView = false
      console.log(this.mapView);
    }
  }

  tripData(type) {
    this.typeOfOrder = type;
    if(type=='scheduled' && this.isTenantDiag)
      this.buttonColor = '#0000005c'
    this.page = 0;
    this.paginator._pageIndex = 0;
    //console.log(type);
    switch (type) {
      case "inplanning":
        this.typeOfTrip = 'TRIP_STATE_IN_PLANNING';
        this.getData('TRIP_STATE_IN_PLANNING', this.fromDate, this.toDate);
        break;
      case "scheduled":
        this.typeOfTrip = 'TRIP_STATE_SCHEDULED';
        this.getData('TRIP_STATE_SCHEDULED', this.fromDate, this.toDate);
        break;
      case "intransit":
        this.typeOfTrip = 'TRIP_STATE_IN_TRANSIT';
        this.getData('TRIP_STATE_IN_TRANSIT', this.fromDate, this.toDate);
        break;
      case "incomplete":
        this.typeOfTrip = 'TRIP_STATE_INCOMPLETE';
        this.getData('TRIP_STATE_INCOMPLETE', this.fromDate, this.toDate);
        break;
      case "completed":
        this.typeOfTrip = 'TRIP_STATE_COMPLETED';
        this.getData('TRIP_STATE_COMPLETED', this.fromDate, this.toDate);
        break;
      default:
        this.typeOfTrip = 'TRIP_STATE_IN_PLANNING';
        this.getData('TRIP_STATE_IN_PLANNING', this.fromDate, this.toDate);
    }
  }

  getData(type, from, to) {
    this.isLoading = true;
    this.tripDataArray.data = [];
    this.totalRecords = 0;
    return this.tripService.getAllTripsByTypesDateRange(type, this.page, from, to, 'nozone').subscribe(res =>{ 
        this.isLoading = false;
      if(this.token.getTenant() == 'vijaya-reta-prod') {
        let groupedObject = res.content.reduce((r, a) => {
          r[a.tripZone] = r[a.tripZone] || [];
          r[a.tripZone].push(a);
          return r;
        }, Object.create(null));
        console.log(groupedObject);

        let combinedArray = [];
        Object.keys(groupedObject).forEach(key => {
          combinedArray =  combinedArray.concat(groupedObject[key]);
        });

        console.log(combinedArray);
      }      
      
      this.totalRecords = res.totalElements;
      this.tripDataArray.data = res.content;

      if (this.tripDataArray.data.length === 0) {
        this.totalRecords = 0;
        this.page = 0;
        this.paginator._pageIndex = 0;
      }
    },Error=>{
      this.isLoading = false;
    });
  }

  pageChanged(event) {
    this.page = event.pageIndex;
    this.getData(this.typeOfTrip, this.fromDate, this.toDate);
  }

  tripDetails(data) {
    let editDialog = this.dialog.open(TripdetailsComponent, {
      width: '800px',
      data: {
        data
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
    editDialog.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  findTrips(days) {
    let date, last, day, month, year;
    date = new Date();
    last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
    day = last.getDate();
    month = last.getMonth();
    year = last.getFullYear();
    this.fromDate = this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd');

    if (days == 1) {
      this.toDate = this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd');
    } else {
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }

    this.findTripCount();

    this.getData(this.typeOfTrip, this.fromDate, this.toDate);

  }

  applyFilter(filterValue: string) {
    this.tripDataArray.filter = filterValue.trim().toLowerCase();
    this.tripDataArray.filterPredicate = (data: any, filter: string) => {
      let isFirstName = false, isLastName = false, isFleet = false;
      if (data) {
        if (data.driver) {
          if (data.driver.firstName) {
            isFirstName = data.driver.firstName.toString().toLowerCase().indexOf(filter) != -1;
          }
          if (data.driver.lastName) {
            isLastName = (data.driver.firstName + " " + data.driver.lastName).toString().toLowerCase().indexOf(filter) != -1 || data.driver.lastName.toString().toLowerCase().indexOf(filter) != -1;
          }
        }
        if (data.fleet) {
          isFleet = data.fleet.vehicleLicenseNumber.toString().toLowerCase().indexOf(filter) != -1;
        }
      }
      return isFirstName || isLastName || isFleet;
    };
  }

}